import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {User} from './user';
import {fetchUserAttributes, signOut} from "@aws-amplify/auth";
import {getCurrentSessionExpireTime} from "@shared/utils/utils";
import {isAfter} from "date-fns/isAfter";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(public router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.getUserDetails();
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  async getUserDetails(){
    const userAttributes = await fetchUserAttributes();
    this.currentUserSubject.next({
      email: userAttributes.email ?? '',
      name: userAttributes.name ?? '',
      role: userAttributes['custom:role'] ?? ''
    });
  }

  error(message: string) {
    return throwError(message);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(this.currentUserValue);
    return of({ success: false });
  }

  async checkSession(): Promise<void> {
    const currentSessionExpireTime = await getCurrentSessionExpireTime();
    if (
      currentSessionExpireTime === 0 ||
      isAfter(new Date(), new Date(currentSessionExpireTime))
    ) {
      signOut().then(() =>  {this.router.navigate(['/auth/sign-in'])} );
    }
  }
}
